<template>
  <v-container class="pa-3">
    <template v-for="(feature, index) in features">
      <!-- The feature item -->
      <v-features-list-item :key="`item-${index}`" :feature="feature" />
      <!-- A divider between the features -->
      <v-divider v-if="index + 1 < features.length" :key="`divider-${index}`" />
    </template>
  </v-container>
</template>

<script>
import { mapState } from "vuex";

import VFeaturesListItem from "./FeaturesListItem.vue";

export default {
  components: {
    VFeaturesListItem
  },
  computed: {
    ...mapState("ner", ['features'])
  }
};
</script>